import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ed735e88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "landing-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("table", {
  class: "row row-1",
  align: "center",
  width: "100%",
  border: "0",
  cellpadding: "0",
  cellspacing: "0",
  role: "presentation",
  style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt"}
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, [
        /*#__PURE__*/_createElementVNode("table", {
          class: "row-content stack",
          align: "center",
          border: "0",
          cellpadding: "0",
          cellspacing: "0",
          role: "presentation",
          style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt","border-radius":"0","color":"#000000","width":"745px","margin":"0 auto"},
          width: "745"
        }, [
          /*#__PURE__*/_createElementVNode("tbody", null, [
            /*#__PURE__*/_createElementVNode("tr", null, [
              /*#__PURE__*/_createElementVNode("td", {
                class: "column column-1",
                width: "100%",
                style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt","font-weight":"400","text-align":"left","padding-bottom":"5px","padding-top":"5px","vertical-align":"top","border-top":"0px","border-right":"0px","border-bottom":"0px","border-left":"0px"}
              }, [
                /*#__PURE__*/_createElementVNode("div", {
                  class: "spacer_block block-1",
                  style: {"height":"30px","line-height":"30px","font-size":"1px"}
                }, "   ")
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("table", {
  class: "row row-2",
  align: "center",
  width: "100%",
  border: "0",
  cellpadding: "0",
  cellspacing: "0",
  role: "presentation",
  style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt","background-size":"auto"}
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, [
        /*#__PURE__*/_createElementVNode("table", {
          class: "row-content stack",
          align: "center",
          border: "0",
          cellpadding: "0",
          cellspacing: "0",
          role: "presentation",
          style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt","background-color":"#ffffff","background-size":"auto","border-radius":"0","color":"#000000","width":"745px","margin":"0 auto"},
          width: "745"
        }, [
          /*#__PURE__*/_createElementVNode("tbody", null, [
            /*#__PURE__*/_createElementVNode("tr", null, [
              /*#__PURE__*/_createElementVNode("td", {
                class: "column column-1",
                width: "100%",
                style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt","font-weight":"400","text-align":"left","padding-bottom":"5px","padding-left":"40px","padding-right":"40px","padding-top":"5px","vertical-align":"top","border-top":"0px","border-right":"0px","border-bottom":"0px","border-left":"0px"}
              }, [
                /*#__PURE__*/_createElementVNode("div", {
                  class: "spacer_block block-1",
                  style: {"height":"50px","line-height":"50px","font-size":"1px"}
                }, "   "),
                /*#__PURE__*/_createElementVNode("table", {
                  class: "image_block block-2",
                  width: "100%",
                  border: "0",
                  cellpadding: "0",
                  cellspacing: "0",
                  role: "presentation",
                  style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt"}
                }, [
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("td", {
                      class: "pad",
                      style: {"width":"100%","padding-right":"0px","padding-left":"0px"}
                    }, [
                      /*#__PURE__*/_createElementVNode("div", {
                        class: "alignment",
                        align: "center",
                        style: {"line-height":"10px"}
                      }, [
                        /*#__PURE__*/_createElementVNode("div", { style: {"max-width":"166.25px"} }, [
                          /*#__PURE__*/_createElementVNode("img", {
                            src: "https://5ed40aab9d.imgdist.com/pub/bfra/v5qme5w2/m1a/e4x/x2x/logo-13.png",
                            style: {"display":"block","height":"auto","border":"0","width":"100%"},
                            width: "166.25",
                            height: "auto"
                          })
                        ])
                      ])
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("table", {
                  class: "divider_block block-3",
                  width: "100%",
                  border: "0",
                  cellpadding: "10",
                  cellspacing: "0",
                  role: "presentation",
                  style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt"}
                }, [
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("td", { class: "pad" }, [
                      /*#__PURE__*/_createElementVNode("div", {
                        class: "alignment",
                        align: "center"
                      }, [
                        /*#__PURE__*/_createElementVNode("table", {
                          border: "0",
                          cellpadding: "0",
                          cellspacing: "0",
                          role: "presentation",
                          width: "95%",
                          style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt"}
                        }, [
                          /*#__PURE__*/_createElementVNode("tr", null, [
                            /*#__PURE__*/_createElementVNode("td", {
                              class: "divider_inner",
                              style: {"font-size":"1px","line-height":"1px","border-top":"1px solid #848484"}
                            }, [
                              /*#__PURE__*/_createElementVNode("span", null, " ")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("table", {
                  class: "heading_block block-4",
                  width: "100%",
                  border: "0",
                  cellpadding: "0",
                  cellspacing: "0",
                  role: "presentation",
                  style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt"}
                }, [
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("td", {
                      class: "pad",
                      style: {"padding-bottom":"30px","padding-left":"10px","padding-right":"10px","text-align":"center","width":"100%"}
                    }, [
                      /*#__PURE__*/_createElementVNode("h1", { style: {"margin":"0","color":"#00a0da","direction":"ltr","font-family":"Arial, Helvetica, sans-serif","font-size":"16px","font-weight":"400","letter-spacing":"normal","line-height":"120%","text-align":"center","margin-top":"0","margin-bottom":"0","mso-line-height-alt":"19.2px"} }, [
                        /*#__PURE__*/_createElementVNode("span", { class: "tinyMce-placeholder" }, [
                          /*#__PURE__*/_createElementVNode("a", {
                            href: "https://www.realtortools.org/",
                            target: "_blank",
                            style: {"text-decoration":"none","color":"#e1b33e"},
                            rel: "noopener"
                          }, [
                            /*#__PURE__*/_createElementVNode("span", {
                              class: "mce-content-body mce-edit-focus",
                              style: {"position":"relative"},
                              id: "8abd68a5-128b-419e-bc10-99024896301c",
                              "data-position": "20-0-3",
                              "data-qa": "tinyeditor-root-element"
                            }, [
                              /*#__PURE__*/_createElementVNode("span", { class: "tinyMce-placeholder" }, "www.realtortools.org")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("table", {
                  class: "heading_block block-5",
                  width: "100%",
                  border: "0",
                  cellpadding: "0",
                  cellspacing: "0",
                  role: "presentation",
                  style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt"}
                }, [
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("td", {
                      class: "pad",
                      style: {"padding-bottom":"10px","padding-left":"60px","padding-right":"60px","padding-top":"10px","text-align":"center","width":"100%"}
                    }, [
                      /*#__PURE__*/_createElementVNode("h1", { style: {"margin":"0","color":"#4d4d4d","direction":"ltr","font-family":"Arial, Helvetica, sans-serif","font-size":"22px","font-weight":"700","letter-spacing":"normal","line-height":"120%","text-align":"center","margin-top":"0","margin-bottom":"0","mso-line-height-alt":"26.4px"} }, " TITLE COMPANY AS A MEMBER OF THE REALTOR TOOLS SYSTEM ")
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("table", {
                  class: "paragraph_block block-6",
                  width: "100%",
                  border: "0",
                  cellpadding: "10",
                  cellspacing: "0",
                  role: "presentation",
                  style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt","word-break":"break-word"}
                }, [
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("td", { class: "pad" }, [
                      /*#__PURE__*/_createElementVNode("div", { style: {"color":"#6b6b6b","direction":"ltr","font-family":"Arial, Helvetica, sans-serif","font-size":"15px","font-weight":"400","letter-spacing":"0px","line-height":"120%","text-align":"center","mso-line-height-alt":"18px"} }, [
                        /*#__PURE__*/_createElementVNode("p", { style: {"margin":"0"} }, " Realtor Tools is a specialized lead generation system for players in the real estate industry. The lead generator is a real estate agent, equipped with 20 arithmetic and financial calculation applications, which are calculated by the System and offered to national and international clients in the residential and investment sectors. The system integrates the participation of Mortgage Loan Originators (MLOs), title companies or real estate attorneys, and home inspectors. . ")
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("table", {
  class: "row row-3",
  align: "center",
  width: "100%",
  border: "0",
  cellpadding: "0",
  cellspacing: "0",
  role: "presentation",
  style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt"}
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, [
        /*#__PURE__*/_createElementVNode("table", {
          class: "row-content stack",
          align: "center",
          border: "0",
          cellpadding: "0",
          cellspacing: "0",
          role: "presentation",
          style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt","background-color":"#ffffff","border-radius":"0","color":"#000000","width":"745px","margin":"0 auto"},
          width: "745"
        }, [
          /*#__PURE__*/_createElementVNode("tbody", null, [
            /*#__PURE__*/_createElementVNode("tr", null, [
              /*#__PURE__*/_createElementVNode("td", {
                class: "column column-1",
                width: "100%",
                style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt","font-weight":"400","text-align":"left","padding-bottom":"5px","padding-top":"5px","vertical-align":"top","border-top":"0px","border-right":"0px","border-bottom":"0px","border-left":"0px"}
              }, [
                /*#__PURE__*/_createElementVNode("div", {
                  class: "spacer_block block-1",
                  style: {"height":"20px","line-height":"20px","font-size":"1px"}
                }, "   "),
                /*#__PURE__*/_createElementVNode("table", {
                  class: "heading_block block-2",
                  width: "100%",
                  border: "0",
                  cellpadding: "0",
                  cellspacing: "0",
                  role: "presentation",
                  style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt"}
                }, [
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("td", {
                      class: "pad",
                      style: {"padding-left":"60px","padding-right":"60px","padding-top":"10px","text-align":"center","width":"100%"}
                    }, [
                      /*#__PURE__*/_createElementVNode("h1", { style: {"margin":"0","color":"#4d4d4d","direction":"ltr","font-family":"Arial, Helvetica, sans-serif","font-size":"18px","font-weight":"700","letter-spacing":"normal","line-height":"120%","text-align":"center","margin-top":"0","margin-bottom":"0","mso-line-height-alt":"21.599999999999998px"} }, [
                        /*#__PURE__*/_createElementVNode("span", { class: "tinyMce-placeholder" }, "BENEFITS FOR TITLE COMPANY OR REAL ESTATE LAYER")
                      ])
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("table", {
                  class: "divider_block block-3",
                  width: "100%",
                  border: "0",
                  cellpadding: "10",
                  cellspacing: "0",
                  role: "presentation",
                  style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt"}
                }, [
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("td", { class: "pad" }, [
                      /*#__PURE__*/_createElementVNode("div", {
                        class: "alignment",
                        align: "center"
                      }, [
                        /*#__PURE__*/_createElementVNode("table", {
                          border: "0",
                          cellpadding: "0",
                          cellspacing: "0",
                          role: "presentation",
                          width: "35%",
                          style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt"}
                        }, [
                          /*#__PURE__*/_createElementVNode("tr", null, [
                            /*#__PURE__*/_createElementVNode("td", {
                              class: "divider_inner",
                              style: {"font-size":"1px","line-height":"1px","border-top":"1px solid #848484"}
                            }, [
                              /*#__PURE__*/_createElementVNode("span", null, " ")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("table", {
  class: "row row-4",
  align: "center",
  width: "100%",
  border: "0",
  cellpadding: "0",
  cellspacing: "0",
  role: "presentation",
  style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt","background-size":"auto"}
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, [
        /*#__PURE__*/_createElementVNode("table", {
          class: "row-content stack",
          align: "center",
          border: "0",
          cellpadding: "0",
          cellspacing: "0",
          role: "presentation",
          style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt","background-color":"#ffffff","background-size":"auto","border-radius":"0","color":"#000000","width":"745px","margin":"0 auto"},
          width: "745"
        }, [
          /*#__PURE__*/_createElementVNode("tbody", null, [
            /*#__PURE__*/_createElementVNode("tr", null, [
              /*#__PURE__*/_createElementVNode("td", {
                class: "column column-1",
                width: "100%",
                style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt","font-weight":"400","text-align":"left","padding-bottom":"5px","padding-left":"40px","padding-right":"40px","padding-top":"5px","vertical-align":"top","border-top":"0px","border-right":"0px","border-bottom":"0px","border-left":"0px"}
              }, [
                /*#__PURE__*/_createElementVNode("table", {
                  class: "image_block block-1",
                  width: "100%",
                  border: "0",
                  cellpadding: "5",
                  cellspacing: "0",
                  role: "presentation",
                  style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt"}
                }, [
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("td", { class: "pad" }, [
                      /*#__PURE__*/_createElementVNode("div", {
                        class: "alignment",
                        align: "center",
                        style: {"line-height":"10px"}
                      }, [
                        /*#__PURE__*/_createElementVNode("div", { style: {"max-width":"99.75px"} }, [
                          /*#__PURE__*/_createElementVNode("img", {
                            src: "https://5ed40aab9d.imgdist.com/pub/bfra/v5qme5w2/4h7/bjo/0pp/iconos-14_1.png",
                            style: {"display":"block","height":"auto","border":"0","width":"100%"},
                            width: "99.75",
                            alt: "I'm an image",
                            title: "I'm an image",
                            height: "auto"
                          })
                        ])
                      ])
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("table", {
                  class: "heading_block block-2",
                  width: "100%",
                  border: "0",
                  cellpadding: "10",
                  cellspacing: "0",
                  role: "presentation",
                  style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt"}
                }, [
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("td", { class: "pad" }, [
                      /*#__PURE__*/_createElementVNode("h1", { style: {"margin":"0","color":"#e1b33e","direction":"ltr","font-family":"Arial, Helvetica, sans-serif","font-size":"18px","font-weight":"700","letter-spacing":"normal","line-height":"120%","text-align":"center","margin-top":"0","margin-bottom":"0","mso-line-height-alt":"21.599999999999998px"} }, [
                        /*#__PURE__*/_createElementVNode("span", { class: "tinyMce-placeholder" }, "Integrated Network")
                      ])
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("table", {
                  class: "paragraph_block block-3",
                  width: "100%",
                  border: "0",
                  cellpadding: "10",
                  cellspacing: "0",
                  role: "presentation",
                  style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt","word-break":"break-word"}
                }, [
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("td", { class: "pad" }, [
                      /*#__PURE__*/_createElementVNode("div", { style: {"color":"#6b6b6b","direction":"ltr","font-family":"Arial, Helvetica, sans-serif","font-size":"15px","font-weight":"400","letter-spacing":"0px","line-height":"120%","text-align":"center","mso-line-height-alt":"18px"} }, [
                        /*#__PURE__*/_createElementVNode("p", { style: {"margin":"0","margin-bottom":"10px"} }, " With the Realtor Tools System aimed at generating and multiplying leads for its members integrated into the System's network, the title companies or real estate attorneys who register in the system are included in a section that will incorporate hundreds of real estate agents, depending on the size of the county, surpassing 1,000 real estate agents who would refer clients to the registered title companies or real estate attorneys within the section. "),
                        /*#__PURE__*/_createElementVNode("p", { style: {"margin":"0"} }, " In each section, there will be a registry of no more than 3 title companies or real estate attorneys who will receive information from those real estate agents generating leads for home purchases, thereby multiplying the possibilities of conducting a greater amount of business. ")
                      ])
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("div", {
                  class: "spacer_block block-4",
                  style: {"height":"35px","line-height":"35px","font-size":"1px"}
                }, "   ")
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("table", {
  class: "row row-5",
  align: "center",
  width: "100%",
  border: "0",
  cellpadding: "0",
  cellspacing: "0",
  role: "presentation",
  style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt"}
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, [
        /*#__PURE__*/_createElementVNode("table", {
          class: "row-content stack",
          align: "center",
          border: "0",
          cellpadding: "0",
          cellspacing: "0",
          role: "presentation",
          style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt","background-color":"#ffffff","border-radius":"0","color":"#000000","width":"745px","margin":"0 auto"},
          width: "745"
        }, [
          /*#__PURE__*/_createElementVNode("tbody", null, [
            /*#__PURE__*/_createElementVNode("tr", null, [
              /*#__PURE__*/_createElementVNode("td", {
                class: "column column-1",
                width: "100%",
                style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt","font-weight":"400","text-align":"left","padding-bottom":"5px","padding-left":"40px","padding-right":"40px","padding-top":"5px","vertical-align":"top","border-top":"0px","border-right":"0px","border-bottom":"0px","border-left":"0px"}
              }, [
                /*#__PURE__*/_createElementVNode("table", {
                  class: "image_block block-1",
                  width: "100%",
                  border: "0",
                  cellpadding: "5",
                  cellspacing: "0",
                  role: "presentation",
                  style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt"}
                }, [
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("td", { class: "pad" }, [
                      /*#__PURE__*/_createElementVNode("div", {
                        class: "alignment",
                        align: "center",
                        style: {"line-height":"10px"}
                      }, [
                        /*#__PURE__*/_createElementVNode("div", { style: {"max-width":"99.75px"} }, [
                          /*#__PURE__*/_createElementVNode("img", {
                            src: "https://5ed40aab9d.imgdist.com/pub/bfra/v5qme5w2/6fg/4er/ebb/iconos-15_1.png",
                            style: {"display":"block","height":"auto","border":"0","width":"100%"},
                            width: "99.75",
                            alt: "I'm an image",
                            title: "I'm an image",
                            height: "auto"
                          })
                        ])
                      ])
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("table", {
                  class: "heading_block block-2",
                  width: "100%",
                  border: "0",
                  cellpadding: "10",
                  cellspacing: "0",
                  role: "presentation",
                  style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt"}
                }, [
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("td", { class: "pad" }, [
                      /*#__PURE__*/_createElementVNode("h1", { style: {"margin":"0","color":"#e1b33e","direction":"ltr","font-family":"Arial, Helvetica, sans-serif","font-size":"18px","font-weight":"700","letter-spacing":"normal","line-height":"120%","text-align":"center","margin-top":"0","margin-bottom":"0","mso-line-height-alt":"21.599999999999998px"} }, [
                        /*#__PURE__*/_createElementVNode("span", { class: "tinyMce-placeholder" }, "National and International Reach")
                      ])
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("table", {
                  class: "paragraph_block block-3",
                  width: "100%",
                  border: "0",
                  cellpadding: "10",
                  cellspacing: "0",
                  role: "presentation",
                  style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt","word-break":"break-word"}
                }, [
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("td", { class: "pad" }, [
                      /*#__PURE__*/_createElementVNode("div", { style: {"color":"#6b6b6b","direction":"ltr","font-family":"Arial, Helvetica, sans-serif","font-size":"15px","font-weight":"400","letter-spacing":"0px","line-height":"120%","text-align":"center","mso-line-height-alt":"18px"} }, [
                        /*#__PURE__*/_createElementVNode("p", { style: {"margin":"0","margin-bottom":"10px"} }, " The system is designed to generate leads at local, national, and international levels, covering both residential and investment national and international clients for a better understanding "),
                        /*#__PURE__*/_createElementVNode("p", { style: {"margin":"0","margin-bottom":"10px"} }, [
                          /*#__PURE__*/_createTextVNode(" go to; "),
                          /*#__PURE__*/_createElementVNode("a", {
                            href: "https://www.realtortools.org/realtor",
                            style: {"text-decoration":"underline","color":"#e1b33e"}
                          }, "https://www.realtortools.org/realtor")
                        ]),
                        /*#__PURE__*/_createElementVNode("p", { style: {"margin":"0"} }, " This allows the  title company or real estate layer  to expand their client base beyond their immediate geographic location, tapping into new markets and opportunities. ")
                      ])
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("div", {
                  class: "spacer_block block-4",
                  style: {"height":"35px","line-height":"35px","font-size":"1px"}
                }, "   ")
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("table", {
  class: "row row-6",
  align: "center",
  width: "100%",
  border: "0",
  cellpadding: "0",
  cellspacing: "0",
  role: "presentation",
  style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt"}
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, [
        /*#__PURE__*/_createElementVNode("table", {
          class: "row-content stack",
          align: "center",
          border: "0",
          cellpadding: "0",
          cellspacing: "0",
          role: "presentation",
          style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt","background-color":"#ffffff","border-radius":"0","color":"#000000","width":"745px","margin":"0 auto"},
          width: "745"
        }, [
          /*#__PURE__*/_createElementVNode("tbody", null, [
            /*#__PURE__*/_createElementVNode("tr", null, [
              /*#__PURE__*/_createElementVNode("td", {
                class: "column column-1",
                width: "100%",
                style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt","font-weight":"400","text-align":"left","padding-bottom":"5px","padding-left":"40px","padding-right":"40px","padding-top":"5px","vertical-align":"top","border-top":"0px","border-right":"0px","border-bottom":"0px","border-left":"0px"}
              }, [
                /*#__PURE__*/_createElementVNode("table", {
                  class: "image_block block-1",
                  width: "100%",
                  border: "0",
                  cellpadding: "0",
                  cellspacing: "0",
                  role: "presentation",
                  style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt"}
                }, [
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("td", {
                      class: "pad",
                      style: {"width":"100%","padding-right":"0px","padding-left":"0px"}
                    }, [
                      /*#__PURE__*/_createElementVNode("div", {
                        class: "alignment",
                        align: "center",
                        style: {"line-height":"10px"}
                      }, [
                        /*#__PURE__*/_createElementVNode("div", { style: {"max-width":"99.75px"} }, [
                          /*#__PURE__*/_createElementVNode("img", {
                            src: "https://5ed40aab9d.imgdist.com/pub/bfra/v5qme5w2/74u/21a/t1l/iconos-16_1.png",
                            style: {"display":"block","height":"auto","border":"0","width":"100%"},
                            width: "99.75",
                            alt: "I'm an image",
                            title: "I'm an image",
                            height: "auto"
                          })
                        ])
                      ])
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("table", {
                  class: "heading_block block-2",
                  width: "100%",
                  border: "0",
                  cellpadding: "10",
                  cellspacing: "0",
                  role: "presentation",
                  style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt"}
                }, [
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("td", { class: "pad" }, [
                      /*#__PURE__*/_createElementVNode("h1", { style: {"margin":"0","color":"#e1b33e","direction":"ltr","font-family":"Arial, Helvetica, sans-serif","font-size":"18px","font-weight":"700","letter-spacing":"normal","line-height":"120%","text-align":"center","margin-top":"0","margin-bottom":"0","mso-line-height-alt":"21.599999999999998px"} }, " Affordable Membership Fee ")
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("table", {
                  class: "paragraph_block block-3",
                  width: "100%",
                  border: "0",
                  cellpadding: "10",
                  cellspacing: "0",
                  role: "presentation",
                  style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt","word-break":"break-word"}
                }, [
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("td", { class: "pad" }, [
                      /*#__PURE__*/_createElementVNode("div", { style: {"color":"#6b6b6b","direction":"ltr","font-family":"Arial, Helvetica, sans-serif","font-size":"15px","font-weight":"400","letter-spacing":"0px","line-height":"120%","text-align":"center","mso-line-height-alt":"18px"} }, [
                        /*#__PURE__*/_createElementVNode("p", { style: {"margin":"0","margin-bottom":"10px"} }, " The introductory membership price is $30.00 per month, with a concurrent payment system. Offering a cost-effective way title companies or real estate layer to gain substantial exposure and new business opportunities. ")
                      ])
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("div", {
                  class: "spacer_block block-4",
                  style: {"height":"60px","line-height":"60px","font-size":"1px"}
                }, "   ")
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("table", {
  class: "row row-7",
  align: "center",
  width: "100%",
  border: "0",
  cellpadding: "0",
  cellspacing: "0",
  role: "presentation",
  style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt"}
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, [
        /*#__PURE__*/_createElementVNode("table", {
          class: "row-content stack",
          align: "center",
          border: "0",
          cellpadding: "0",
          cellspacing: "0",
          role: "presentation",
          style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt","background-color":"#000000","border-radius":"0","color":"#000000","width":"745px","margin":"0 auto"},
          width: "745"
        }, [
          /*#__PURE__*/_createElementVNode("tbody", null, [
            /*#__PURE__*/_createElementVNode("tr", null, [
              /*#__PURE__*/_createElementVNode("td", {
                class: "column column-1",
                width: "100%",
                style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt","font-weight":"400","text-align":"left","padding-bottom":"30px","padding-left":"40px","padding-right":"40px","padding-top":"30px","vertical-align":"top","border-top":"0px","border-right":"0px","border-bottom":"0px","border-left":"0px"}
              }, [
                /*#__PURE__*/_createElementVNode("table", {
                  class: "paragraph_block block-1",
                  width: "100%",
                  border: "0",
                  cellpadding: "10",
                  cellspacing: "0",
                  role: "presentation",
                  style: {"mso-table-lspace":"0pt","mso-table-rspace":"0pt","word-break":"break-word"}
                }, [
                  /*#__PURE__*/_createElementVNode("tr", null, [
                    /*#__PURE__*/_createElementVNode("td", { class: "pad" }, [
                      /*#__PURE__*/_createElementVNode("div", { style: {"color":"#ffffff","direction":"ltr","font-family":"Arial, Helvetica, sans-serif","font-size":"14px","font-weight":"400","letter-spacing":"0px","line-height":"120%","text-align":"center","mso-line-height-alt":"16.8px"} }, [
                        /*#__PURE__*/_createElementVNode("p", { style: {"margin":"0"} }, [
                          /*#__PURE__*/_createElementVNode("strong", null, "Note:"),
                          /*#__PURE__*/_createTextVNode(" We are beginning the registration of real estate industry actors in the states of CA, FL, GA, NJ, TX, NY AND NC. ")
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1))
const _hoisted_9 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_9))
}